import { customAlphabet } from "nanoid"

// Short public identifier for URL-visible entities (trips, guides). Internal
// PKs stay uuid everywhere (FKs, day_sequence/items arrays, command log,
// realtime channels) — this exists only so shared links aren't 36 chars of
// hex. Lowercase alphanumeric: case-insensitive-safe, no `-`/`_` so it can
// never be mistaken for the slug segment next to it. 36^10 ≈ 3.6e15 — the
// unique index is the real collision guard.
export const SHORT_ID_LENGTH = 10

export const generateShortId = customAlphabet(
  `0123456789abcdefghijklmnopqrstuvwxyz`,
  SHORT_ID_LENGTH,
)

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

// Route params accept both forms forever (old uuid links must keep working);
// a 10-char short id can never match the 36-char uuid shape.
export function isUuid(value: string): boolean {
  return UUID_RE.test(value)
}
